import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { TicketStore } from "@app/services/store/ticket-store";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { ResourceAvailabilityStore } from "@app/services/store/resource-availability-store";
import { JobStore } from "@app/services/store/job-store";
import { Job_DetailProjection } from "@app/models/rest/job";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatToolbar } from "@angular/material/toolbar";
import { PropertyInfoComponent } from "../../../integrations/urm/views/property-info/property-info.component";

@Component({
  selector: "app-job-info-dialog",
  templateUrl: "./job-info-dialog.component.html",
  styleUrls: ["./job-info-dialog.component.css"],
  imports: [CdkScrollable, MatDialogContent, MatToolbar, PropertyInfoComponent]
})
export class JobInfoDialogComponent implements OnInit {
  private clientConfigService = inject(ClientConfigService);
  dialogRef = inject<MatDialogRef<JobInfoDialogComponent>>(MatDialogRef);
  ticketStore = inject(TicketStore);
  jobStore = inject(JobStore);
  protected serviceErrorHandler = inject(ServiceErrorHandlerService);
  resourceAvailabilityStore = inject(ResourceAvailabilityStore);
  data = inject(MAT_DIALOG_DATA);

  public job: Job_DetailProjection;
  public urmEnabled: boolean = false;

  constructor() {
    this.urmEnabled = this.clientConfigService.config.urmServices.enabled;
  }

  ngOnInit() {
    if (!this.data.ticket) return;
    this.jobStore
      .loadSingleProjection(
        Job_DetailProjection,
        this.data.ticket.visit.job.id,
        "detail"
      )
      .then((value) => {
        this.job = value;
      })
      .catch((reason) => {
        this.serviceErrorHandler.handleError(reason);
      });
  }
}
